module.exports = __webpack_public_path__ + "img/autarky_navbar_bg.7a70f9ee.png";